export default "__VITE_ASSET__Dco5jpCO__"